module.exports = __webpack_public_path__ + "static/media/image_20.97b95fc4.png";